import app from '@/app';

/* @ngInject */
const resource = abstractResource => abstractResource('road');

app.factory('Road', resource);
